const config = [
  {
    header: 'School Statistics (K-12)',
    trackingFieldName: 'school_open',
    className: 'clSchool',
    help: '',
    contentConfig: [
      {
        type: 'variable',
        rows: [
          { text: 'Average public school rating on GreatSchools.com' },
          { key: 'greatschools_rating' },
        ],
      },
      {
        type: 'variable',
        rows: [
          { text: 'Number of private schools' },
          { key: 'total_private_schools' },
        ],
      },
      {
        type: 'variable',
        rows: [
          { text: 'Number of private elementary schools' },
          { key: 'total_private_k_8_schools' },
        ],
      },
      {
        type: 'variable',
        rows: [
          { text: 'Number of private high schools' },
          { key: 'total_private_high_schools' },
        ],
      },
      {
        type: 'variable',
        rows: [
          { text: 'Estimated average private high school tuition' },
          { key: 'private_school_tuition_cost' },
        ],
      },
    ],
  },
];
export default config;
